import { put, takeEvery } from 'redux-saga/effects'

import API from '../api/REST'
import {
  getExplainSetup,
  getAllGaMetrics,
  saveExplainSetup,
  addMetric,
  updateMetric,
  getCurrentKeyMetrics,
  getAnomalyDateDescription,
  getAllGaDimensions,
  updateAnomalyDescription,
} from '../api/REST/explain-client'

export const clientInstance = API

function* getCurrentKeyMetricsAsync(): IterableIterator<ReduxAction | any> {
  const payload: any = yield getCurrentKeyMetrics()

  if (payload) {
    yield put({
      type: 'GET_CURRENT_KEY_METRICS',
      payload,
    })
  }
}

function* getAnomalyDateDescriptionAsync(
  action: ReduxAction,
): IterableIterator<ReduxAction | any> {
  yield put({
    type: 'START_LOADING_ANOMALY_DESCRIPTION',
  })

  const payload: any = yield getAnomalyDateDescription(action.payload)

  if (payload) {
    yield put({
      type: 'GET_ANOMALY_DESCRIPTION',
      payload,
    })
  }
}

function* updateAnomalyDescriptionReducersOnly(
  action: any,
): IterableIterator<ReduxAction | any> {
  yield put({
    type: 'UPDATE_LOADED_ANOMALIES',
    payload: { ...action.payload },
  })
  yield put({
    type: 'UPDATE_ANOMALY_DESCRIPTION',
    payload: { ...action.payload },
  })
}

function* updateAnomalyDescriptionAsync(
  action: any,
): IterableIterator<ReduxAction | any> {
  const {
    anomalyDateID,
    likedCauses,
    dislikedCauses,
    likedActions,
    dislikedActions,
    userSuppliedCause,
    userSuppliedAction,
    userSuppliedEffort,
    userSuppliedBenefit,
    selectedRelevantDimensions,
    anomalyNotInteresting,
  } = action.payload

  const data = {
    anomalyDateID,
    likedCauses,
    dislikedCauses,
    likedActions,
    dislikedActions,
    userSuppliedCause,
    userSuppliedAction,
    userSuppliedEffort,
    selectedRelevantDimensions,
    userSuppliedBenefit,
    anomalyNotInteresting,
  }

  yield updateAnomalyDescription(data)
  // const payload: any = yield updateAnomalyDescription(data)

  if (action.payload !== false) {
    yield put({
      type: 'UPDATE_ANOMALY_DESCRIPTION',
      payload: action.payload,
    })
    yield put({
      type: 'UPDATE_LOADED_ANOMALIES',
      payload: action.payload,
    })
  }
}

function* getAllGaDimensionsAsync(): IterableIterator<ReduxAction | any> {
  const payload: any = yield getAllGaDimensions()

  if (payload) {
    yield put({
      type: 'GET_ALL_GA_DIMENSIONS',
      payload,
    })
  }
}

function* getUserListAsync(): IterableIterator<ReduxAction | any> {
  const payload: any = yield API.getUserList()
  if (payload) {
    yield put({
      type: 'GET_USER_LIST',
      payload,
    })
  }
}

function* getExplainSetupAsync(): IterableIterator<ReduxAction | any> {
  yield put({
    type: 'START_LOADING_EXPLAIN_SETUP',
  })

  const payload: any = yield getExplainSetup()

  if (payload) {
    yield put({
      type: 'GET_EXPLAIN_SETUP',
      payload,
    })
  }
}

function* updateMetricAsync(action: any): IterableIterator<ReduxAction | any> {
  yield updateMetric({
    ...action.payload,
  })

  // Load up change
  yield put({
    type: 'GET_EXPLAIN_SETUP_ASYNC',
  })

  yield put({
    type: 'GET_CURRENT_KEY_METRICS_ASYNC',
  })
}

function* addMetricAsync(action: any): IterableIterator<ReduxAction | any> {
  yield addMetric({
    ...action.payload,
  })

  // Load up change
  yield put({
    type: 'GET_EXPLAIN_SETUP_ASYNC',
  })

  yield put({
    type: 'GET_CURRENT_KEY_METRICS_ASYNC',
  })
}

function* saveExplainSetupAsync(
  action: any,
): IterableIterator<ReduxAction | any> {
  if (action.payload) {
    yield put({
      type: 'SAVE_EXPLAIN_SETUP',
      payload: action.payload,
    })
  }
  yield saveExplainSetup({
    pageLayout: action.payload.pageLayout,
    settings: action.payload.settings,
  })
}

function* getAllGaMetricsAsync(): IterableIterator<ReduxAction | any> {
  const payload: any = yield getAllGaMetrics()

  if (payload) {
    yield put({
      type: 'GET_GA_METRICS',
      payload,
    })
  }
}

function* getGooglePermissions(
  action: ReduxAction,
): IterableIterator<ReduxAction | any> {
  yield API.getGooglePermissions(action.payload)
}

function* getAnomalyDataRange(
  action: ReduxAction,
): IterableIterator<ReduxAction | any> {
  const { metricID, from, to, selector } = action.payload

  yield put({
    type: 'START_NEW_ANOMALY_DATE_RANGE_SEARCH',
    payload: metricID,
  })

  const res: any = yield API.getAnomalyDataRange(metricID, from, to)

  if (res && res.data && res.data.anomalyRange) {
    yield put({
      type: 'UPDATE_ANOMALY_GRAPH',
      payload: {
        metricID,
        ...res.data,
        lastRange: {
          from,
          to,
          selector,
        },
        callData: {
          loading: false,
        },
      },
    })
  } else {
    yield put({
      type: 'FAILED_LOADING_ANOMALY_GRAPH',
      payload: {
        metricID,
        lastRange: {
          from,
          to,
          selector,
        },
      },
    })
  }
}

function* getCausesAndSolutions(
  action: ReduxAction,
): IterableIterator<ReduxAction | any> {
  const {
    anomalyDateID,
  }: {
    anomalyDateID: string
  } = action.payload

  yield put({
    type: 'START_LOADING_ANOMALY_BREAKDOWN_CAUSES',
  })

  const payload: any = yield API.getCausesAndSolutions(anomalyDateID)
  if (!payload) {
    yield put({
      type: 'GET_ANOMALY_BREAKDOWN_CAUSES',
      payload: { recommendedCauses: [] },
    })
    return
  }

  yield put({
    type: 'GET_ANOMALY_BREAKDOWN_CAUSES',
    payload,
  })
}

function* getAllUsers(): IterableIterator<ReduxAction | any> {
  const payload = yield API.getAllUsers()

  yield put({
    type: 'GET_ALL_USERS',
    payload,
  })
}

function* closeAccounts(): IterableIterator<ReduxAction | any> {
  yield API.closeAccounts()
}

function* logout(): IterableIterator<ReduxAction | any> {
  yield API.logout()
  yield put({
    type: 'LOGOUT',
  })
}

function* getSelectedAccount(): IterableIterator<ReduxAction | any> {
  const selected = yield API.getAccountSelected()
  if (selected) {
    yield put({
      type: 'GET_SELECTED_ACCOUNT',
      payload: selected,
    })
  }
}

function* getAAFTPDetailsAsync(): IterableIterator<ReduxAction | any> {
  const res = yield API.getAAFTPDetails()
  if (!res) return
  yield put({
    type: 'GET_FTP_DETAILS',
    payload: res,
  })
}

export default function* rootSaga(): IterableIterator<any> {
  yield takeEvery('GET_GOOGLE_PERMISSION_ASYNC', getGooglePermissions)
  yield takeEvery('GET_ANOMALY_RANGE_ASYNC', getAnomalyDataRange)
  yield takeEvery('GET_ANOMALY_BREAKDOWN_CAUSES_ASYNC', getCausesAndSolutions)
  yield takeEvery('GET_AA_FTP_DETAILS_ASYNC', getAAFTPDetailsAsync)
  yield takeEvery('GET_ALL_USERS_ASYNC', getAllUsers)
  yield takeEvery('GET_SELECTED_ACCOUNT_ASYNC', getSelectedAccount)
  yield takeEvery('CLOSE_ACCOUNTS_ASYNC', closeAccounts)
  yield takeEvery('DELETE_TOKEN', logout)
  yield takeEvery('GET_EXPLAIN_SETUP_ASYNC', getExplainSetupAsync)
  yield takeEvery('GET_GA_METRICS_ASYNC', getAllGaMetricsAsync)
  yield takeEvery('SAVE_EXPLAIN_SETUP_ASYNC', saveExplainSetupAsync)
  yield takeEvery('ADD_METRIC_ASYNC', addMetricAsync)
  yield takeEvery('UPDATE_METRIC_ASYNC', updateMetricAsync)
  yield takeEvery('GET_CURRENT_KEY_METRICS_ASYNC', getCurrentKeyMetricsAsync)
  yield takeEvery(
    'GET_ANOMALY_DESCRIPTION_ASYNC',
    getAnomalyDateDescriptionAsync,
  )
  yield takeEvery(
    'UPDATE_ANOMALY_DESCRIPTION_ASYNC',
    updateAnomalyDescriptionAsync,
  )
  yield takeEvery('GET_ALL_GA_DIMENSIONS_ASYNC', getAllGaDimensionsAsync)
  yield takeEvery('GET_USER_LIST_ASYNC', getUserListAsync)
  yield takeEvery(
    'UPDATE_ANOMALY_REDUCERS_ONLY',
    updateAnomalyDescriptionReducersOnly,
  )
}
